import React from "react";
import { observer } from "mobx-react";
import cookieStore from "./CokiesStore.js";
import cookiesimage from "../../Assets/Authentication/cookie (1).png";

const CookieConsentPopup = observer(() => {
  if (cookieStore.consentGiven || !cookieStore.showConsent) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 1000,
        backgroundColor: "#fff",
        border: "1px solid #ddd",
        borderRadius: "10px",
        boxShadow: "0 6px 18px rgba(0, 0, 0, 0.1)",
        padding: "16px 20px",
        maxWidth: "320px",
        width: "100%",
        fontSize: "14px",
        transition: "opacity 0.3s ease-in-out",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img
            src={cookiesimage}
            alt="Cookies"
            style={{ height: "30px", width: "30px" }}
          />
          <h6 style={{ margin: 0, fontWeight: "600" }}>Cookies</h6>
        </div>
        <button
          onClick={cookieStore.hideCokies}
          style={{
            border: "none",
            background: "none",
            fontSize: "18px",
            lineHeight: "1",
            cursor: "pointer",
            color: "#999",
          }}
          aria-label="Close"
        >
          &times;
        </button>
      </div>

      <p style={{ margin: "12px 0", color: "#555" }}>
        Cookies help us enrich your experience and ensure the security of this app.
      </p>

      <div style={{ textAlign: "right" }}>
        <button
          className="btn btn-sm btn-outline-secondary me-2"
          onClick={cookieStore.hideConsent}
        >
          Maybe Later
        </button>
        <button
          className="btn btn-sm btn-primary"
          onClick={cookieStore.giveConsent}
        >
          Accept Cookies
        </button>
      </div>
    </div>
  );
});

export default CookieConsentPopup;
